import React from 'react';
import classNames from "classnames";
import '../../dashboard.scss';

type CustomLegendProps = {
    text: string;
    amount?: number;
    subText?: string;
    color: string;
    additionalClasses?: string;
    active?: boolean;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    onClickCallback?: () => void;
}

export const CustomLegend = ({
                                 text,
                                 color,
                                 onMouseEnter,
                                 onMouseLeave,
                                 active = false,
                                 additionalClasses,
                                 onClickCallback,
                                 subText,
                                 amount
                             }: CustomLegendProps) => {
    return (
        <div className={classNames("flex-align-c padding-tbr-s", additionalClasses)}
             style={{cursor: onClickCallback ? "pointer" : "default"}}
             onMouseEnter={onMouseEnter}
             onMouseLeave={onMouseLeave}
             onClick={onClickCallback}
        >
            <div style={{backgroundColor: color, borderColor: color}}
                 className={classNames("legend-square", active && "hover-legend")}>
            </div>
            <div className={"margin-left-s legend-text flex-container-row wrap"}>
                {text}
                {subText && <div className={"subtle"}>&nbsp;{subText}</div>}
                {amount !== undefined && <div>&nbsp;{`(${amount})`}</div>}
            </div>
        </div>
    );
};
